//Show hide Clear All functionality - Search type ahead
function showHideClearAll() {
  const searchInput = document.querySelector(".search-modal--wrap__flex .search__input");
  const clearAll = document.querySelector(".search__clear-all");

  if(searchInput) {
    searchInput.addEventListener("input", () => {
      const value = searchInput.value;
  
      if(value.length > 0) {
        //Show clear all if the user starts typing. Otherwise, hide.
        if(clearAll.classList.contains("hidden")) {
          clearAll.classList.remove("hidden");
        }
      }
      else {
        if(!clearAll.classList.contains("hidden")) {
          clearAll.classList.add("hidden");
        }
      }
    });
  }
}

//Clear all click functionality
function clearAllClick() {
  const searchInput = document.querySelector(".search-modal--wrap__flex .search__input");
  const clearAll = document.querySelector(".search__clear-all");

  if(clearAll) {
    clearAll.addEventListener("click", () => {
      if(searchInput) {
        //Set search bar value to empty if clear all is clicked
        searchInput.value = "";

        if(!clearAll.classList.contains("hidden")) {
          clearAll.classList.add("hidden");
        }
      }
    });

    clearAll.addEventListener("keypress", (event) => {
      if(event.key === "Enter" && searchInput) {
        searchInput.value = "";

        if(!clearAll.classList.contains("hidden")) {
          clearAll.classList.add("hidden");
        }
      }
    });
  }
}

showHideClearAll();
clearAllClick();